import GameSignals from '@/signals/GameSignals'
import { BaseChildState } from '@stateMachine/BaseChildState'
import gsap from 'gsap'

export class FreeSpinsSummaryState extends BaseChildState {
    private _transitionFallbackTimeoutId: number = null
    private _isTransitionHandled: boolean = false
    private _isCompleted: boolean = false

    public canTrigger(): boolean {
        return !this._model.isPromoSpinsRound() && this._model.spinData.freebet && this._model.spinData.freebet.amount_left === 0
    }

    public begin() {
        GameSignals.showFreeSpinsSummaryComplete.connect(this.onSummaryComplete)
        this._isCompleted = false

        gsap.to(this, {
            duration: 0.5,
            onComplete: () => {
                GameSignals.showFreeSpinsSummary.emit(this._model.winCounter.totalWin)
            }
        })
    }

    private onSummaryComplete = () => {
        if (this._isCompleted) {
            return
        }

        this._isCompleted = true
        this._isTransitionHandled = false
        GameSignals.completeTransitionAnimation.connect(this.onBonusEndTransitionComplete)

        this._model.isBonusGameNow = false
        this._model.roundState.isFreeSpins = false

        // Start transition and background switch together
        GameSignals.showBaseGameBackground.emit()

        // Trigger transition at bonus end
        GameSignals.bonusStop.emit(this._model.winCurrency)

        // Safety fallback in case transition animation does not emit completion
        this._transitionFallbackTimeoutId = window.setTimeout(this.onBonusEndTransitionComplete, 2200)
    }

    private onBonusEndTransitionComplete = () => {
        if (this._isTransitionHandled) {
            return
        }

        this._isTransitionHandled = true

        if (this._transitionFallbackTimeoutId !== null) {
            clearTimeout(this._transitionFallbackTimeoutId)
            this._transitionFallbackTimeoutId = null
        }

        GameSignals.completeTransitionAnimation.disconnect(this.onBonusEndTransitionComplete)

        const timeline = gsap.timeline()
        timeline.to(this, {
            duration: 0.1,
            onComplete: () => {
                GameSignals.showBaseGameBackground.emit()
                GameSignals.bonusStopComplete.emit()
            }
        }).to(this, {
            duration: 0.2,
            onComplete: () => {
                gsap.killTweensOf(this)
                this.end()
            }
        })
    }

    public cleanUp() {
        if (this._transitionFallbackTimeoutId !== null) {
            clearTimeout(this._transitionFallbackTimeoutId)
            this._transitionFallbackTimeoutId = null
        }

        GameSignals.showFreeSpinsSummaryComplete.disconnect(this.onSummaryComplete)
        GameSignals.completeTransitionAnimation.disconnect(this.onBonusEndTransitionComplete)
    }
}
